// extracted by mini-css-extract-plugin
export default {"noResults":"styles_noResults__EwrQA"};